import React from 'react';
import { ShieldAlert } from 'lucide-react';
export function TrustSection() {
  return <section className="py-10 px-4 bg-gradient-to-br from-brand-gold-light to-white pb-8 md:pb-8" data-id="element-319">
      <div className="max-w-4xl mx-auto" data-id="element-320">
        <div className="bg-white rounded-[20px] shadow-xl p-8 border-2 border-brand-gold" data-id="element-321">
          <div className="flex flex-col items-center text-center" data-id="element-322">
            <div className="bg-brand-gold rounded-full p-4 mb-4" data-id="element-323">
              <ShieldAlert className="w-10 h-10 text-white" data-id="element-324" />
            </div>
            <h3 className="text-2xl md:text-3xl font-bold font-serif text-gray-900 mb-4" data-id="element-325">
              Garantía Profesional de Resultados
            </h3>
            <div className="bg-brand-teal text-white py-2 px-6 rounded-full mb-4" data-id="element-326">
              <span className="font-bold text-lg" data-id="element-327">14 Días</span>
            </div>
            <p className="text-gray-700 text-base max-w-2xl leading-relaxed" data-id="element-328">
              Si usted aplica el protocolo y no ve una reducción visible en el
              estrés de su perro durante los paseos, le devolvemos el{' '}
              <strong data-id="element-329">100% de su inversión</strong>. Sin preguntas.
            </p>
          </div>
        </div>
      </div>
    </section>;
}